import { FormattedMessage } from 'react-intl';
import { getAssetUrl } from '../../../utils/config';
import { getCarrierI18nKey } from '../../molecules/CarrierOptions';
import './style.scss';

type DeliveryEstimateProps = {
  min: string;
  max: string;
  carrier?: string;
  isCondensed?: boolean;
};

const DeliveryEstimate = (props: DeliveryEstimateProps) => {
  const { min, max, carrier, isCondensed } = props;

  return (
    <div className="delivery-estimate">
      <div className="delivery-estimate--desktop">
        <FormattedMessage
          id="basket.deliveryEstimate"
          values={{
            min: new Date(min),
            max: new Date(max),
          }}
        />
        {!!carrier && (
          <>
            &nbsp; &bull; &nbsp;
            <img
              className="delivery-estimate__carrier-logo"
              src={getAssetUrl(`carriers/${getCarrierI18nKey(carrier)}.svg`)}
            />
          </>
        )}
      </div>
      <div className="delivery-estimate--mobile">
        {!isCondensed && !!carrier && (
          <>
            <FormattedMessage
              id="basket.deliveryEstimate"
              values={{
                min: new Date(min),
                max: new Date(max),
              }}
            />
            &nbsp; &bull; &nbsp;
            <img
              className="delivery-estimate__carrier-logo"
              src={getAssetUrl(`carriers/${getCarrierI18nKey(carrier)}.svg`)}
            />
          </>
        )}
        {!isCondensed && !carrier && (
          <FormattedMessage
            id="basket.deliveryEstimate"
            values={{
              min: new Date(min),
              max: new Date(max),
            }}
          />
        )}
      </div>
    </div>
  );
};

export default DeliveryEstimate;
